export default __webpack_public_path__ + "static/media/img_fukidashi1.26a46faa.svg";